/**
 * ====================================
 * KLASYS - Correspondance droits <-> licence
 * ====================================
 *
 * A gauche le nom du module tel qu'il existe dans la table `permissions`, a
 * droite la ou les cles du catalogue CIK (voir LICENCES-CATALOGUE.md).
 *
 * Les deux nomenclatures ne se recouvrent pas exactement, et c'est voulu : les
 * droits internes decoupent l'application par ecran, la licence la decoupe par
 * ce qui se vend. Cette table est le seul endroit ou les deux se rencontrent —
 * elle est partagee par le menu (SidebarNav) et par les gardes de route
 * (ProtectedRoute) pour qu'ils ne puissent jamais dire deux choses differentes.
 *
 * Plusieurs cles = l'acces s'ouvre des qu'UNE d'entre elles est souscrite.
 * C'est le cas de COMPTABILITE_ET_PAIE, un seul module de droits mais deux
 * modules vendus separement : une ecole qui n'a que la comptabilite doit
 * garder son ecran.
 *
 * Un module absent de cette table releve du socle et n'est jamais filtre par la
 * licence : OUTILS_ADMINISTRATIFS, ADMINISTRATION, PARAMETRES, MISSION_CONTROL,
 * ALL_MODULES.
 */

export const LICENCE_PAR_MODULE = {
  ELEVES: ['module.eleves'],
  CANTINE: ['module.cantine'],
  RESSOURCE_HUMAINES: ['module.rh'],

  // Paires porte / actions. Le modele de droits distingue le module qui ouvre
  // l'ecran (CLASSE_ET_MATIERES, CARNET_EVALUATION — une seule permission
  // ACCESS chacun) du module qui porte les actions (CLASSES 14 permissions,
  // NOTES 11). Ce ne sont pas des doublons : les deux doivent porter la meme
  // cle de licence, sinon l'ecran « Acces et securite » laisserait regler les
  // actions d'un module ferme.
  CLASSE_ET_MATIERES: ['module.classes_matieres'],
  CLASSES: ['module.classes_matieres'],
  CARNET_EVALUATION: ['module.evaluations'],
  NOTES: ['module.evaluations'],

  COMPTABILITE_ET_PAIE: ['module.comptabilite', 'module.paie'],
  INSCRIPTION_AUX_EXAMENS: ['module.examens'],
  TACHES: ['module.taches'],
  LIAISON_INTER_SITES: ['module.intersites'],
  TENDANCES_ET_ANALYSE: ['module.analyse'],
  SUIVI_ENSEIGNANTS: ['module.suivi_enseignants'],
  MESSAGERIE: ['module.messagerie'],
  POINTAGES: ['module.pointage'],

  // Un module de droits, deux modules vendus (décision du 02/11/2026) : le
  // parc et les bus scolaires (lot 3b, 03/11/2026). L'accès s'ouvre dès que
  // l'un des deux est souscrit ; chaque onglet suit sa propre clé.
  LOGISTIQUE: ['module.logistique_parc', 'module.logistique_transport']
};

/**
 * Cles de licence exigees par un module de droits.
 * Tableau vide = module du socle, aucune exigence.
 */
export const clesLicence = (module) => LICENCE_PAR_MODULE[module] || [];

export default LICENCE_PAR_MODULE;
